/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiLoadSpinnerIcon64Regular = forwardRef('UiLoadSpinnerIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M32 9C19.297 9 9 19.297 9 32s10.297 23 23 23 23-10.297 23-23a1.5 1.5 0 0 1 3 0c0 14.36-11.64 26-26 26S6 46.36 6 32 17.64 6 32 6a1.5 1.5 0 0 1 0 3Z" })));
});
